require('./lbaSubNav.scss');

const lbaSubNav = angular.module('app.lbaSubNav', []);

lbaSubNav.component('lbaSubNav', {
    bindings: {},
    controllerAs: 'vm',
    controller: ['$location', 'subNavService', 'formValidationService', '$rootScope', 'dataService' , controller],
    template: require('./lbaSubNav.html')
});

function controller($location, subNavService, formValidationService, $rootScope, dataService) {
    let vm = this;
    vm.subNav = subNavService;
    $rootScope.navObj
    vm.showTab = showTab;

    function showTab(link) {
      // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
      dataService.backGridFilter = null;
      dataService.backGridPage = null;
      dataService.backViewGridFilter = null;
      dataService.backViewGridPage = null;

      $location.path(link);
    }

}

export default lbaSubNav;



// WEBPACK FOOTER //
// ./src/components/lbaSubNav/lbaSubNav.js